<template>
	<div class="project-english-read-only-name">
		<v-layout row>
			<v-flex xs12 md12>
				<v-card style="margin: 10px">
					<v-card-title>
						<h3>Angielski tytuł projektu</h3>
					</v-card-title>
					<v-card-text>
						<v-flex xs12 md12>
							<display-text-component
								class="modular"
								label="Angielski tytuł projektu"
								:value="value"/>
						</v-flex>
					</v-card-text>
				</v-card>
			</v-flex>
		</v-layout>
	</div>
</template>

<script>
	import DisplayTextComponent from "../../offer/components/DisplayTextComponent";

	export default {
		name: "ProjectEnglishNameReadOnlyView",
		components: {DisplayTextComponent},

		methods: {
			validate () {
				return true;
			}
		},

		props: {
			value: String
		},
	};
</script>

<style scoped>
	.project-english-read-only-name {
		margin-bottom: 10px;
	}
</style>